import { Box } from '@chakra-ui/react';

interface IFingerNote {
  title: React.ReactNode;
  description: React.ReactNode;
}

export const FingerNote = ({ title, description }: IFingerNote) => {
  return (
    <Box bgColor={'chakra-subtle-bg'} lineHeight={5} borderRadius={'lg'} gap={2} py={3} pl={4} my={3}>
      <Box fontWeight={'medium'} mb={1}>
        {title}
      </Box>
      {description}
    </Box>
  );
};
